import { useEffect } from "react";

import {
  isDomainBx,
  isDomainMmi,
  isDomainOneascent,
} from "../utils/helper/specialized";
import { setHeadAttributes } from "../utils/helper/general";

import favicon_level from "../ecosystem/wealth/image/favicon.ico";
import favicon_oneascent from "../ecosystem/oneascent/image/favicon.png";
import favicon_mmi from "../ecosystem/mmi/images/favicon.ico";

const MetaDataProvider = ({ children }) => {
  useEffect(() => {
    setPageMetadataBasedOnDomain();
  }, []);

  const setPageMetadataBasedOnDomain = () => {
    if (isDomainBx()) {
      setHeadAttributes({
        documentTitle: "BX",
        faviconUrl: favicon_level,
        metaDescription:
          "Chart your course to financial independence with BX advanced financial planning software.",
      });
    } else if (isDomainOneascent()) {
      setHeadAttributes({
        documentTitle: "OneAscent",
        faviconUrl: favicon_oneascent,
        metaDescription:
          "Chart your course to financial independence with OneAscent's advanced financial planning software.",
      });
    } else if (isDomainMmi()) {
      setHeadAttributes({
        documentTitle: "Thrive",
        faviconUrl: favicon_mmi,
        metaDescription: "Thrive software.",
      });
    } else {
      setHeadAttributes({
        documentTitle: "CleverCX",
        faviconUrl: favicon_level,
        metaDescription:
          "Chart your course to financial independence with CleverCX advanced financial planning software.",
      });
    }
  };

  return children;
};

export default MetaDataProvider;
